<template>
	<nuxt-layout>
		<NuxtPage />
	</nuxt-layout>
</template>
<script>
export default {
	name: "Default",
}
</script>
